import React, { useState, useEffect } from 'react'
import Navbar from './Navbar'
import Sidebar from './Sidebar'
import RespSidebar from './RespSidebar'
import { motion } from 'framer-motion';
import ibm from '../images/image.png'
import gcpace from '../images/associate-cloud-engineer-certification.png'
import genaioracle from '../images/image oracle.png'
import Certificate from './Certificate'
import {
  FileText,
  Eye,
  Award,
  Github,
  ExternalLink,
} from "lucide-react";
export default function Resume() {
  const [Drop, setDrop] = useState(false)
  const [badgeCount, setBadgeCount] = useState(18)
  const [repoCount, setRepoCount] = useState(16)
  const [resumeDate, setResumeDate] = useState("Updated 22 August, 2026")
  const [ShowCertificate1, setShowCertificate1] = useState({
    isShow: false,
    cretificateName : "",
    cretificateDescripton : "",
    certificateImageSrc : "",
    cretificateLink : "",
    certificateDate : ""
  })

  useEffect(() => {
    // Fetch GitHub public repositories count
    fetch("https://api.github.com/users/Ujwal-Hiranwar")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch GitHub data");
        return res.json();
      })
      .then((data) => {
        if (typeof data.public_repos === "number") {
          setRepoCount(data.public_repos);
        }
      })
      .catch((err) => console.error("Error fetching GitHub repos:", err));

    // Fetch Credly badges count
    const fetchCredlyBadges = async () => {
      const endpoints = [
        "/api/credly",
        "https://www.credly.com/users/ujwalhiranwar/badges.json"
      ];

      for (const url of endpoints) {
        try {
          const res = await fetch(url);
          if (!res.ok) continue;
          const data = await res.json();
          const count = data?.count ?? data?.metadata?.total_count ?? data?.data?.length;
          if (typeof count === "number" && count > 0) {
            setBadgeCount(count);
            return;
          }
        } catch (e) {
          // Ignore error and try next endpoint
        }
      }
    };

    // Fetch Google Drive Resume PDF last modified date
    const fetchResumeDate = async () => {
      try {
        const res = await fetch("/api/resume-date");
        if (res.ok) {
          const data = await res.json();
          if (data?.formattedDate) {
            setResumeDate(data.formattedDate);
            return;
          }
        }
      } catch (e) {
        // Fallback to direct HEAD request
      }

      try {
        const driveRes = await fetch(
          "https://drive.google.com/uc?export=download&id=1ysYVYU9X6q3uBaLDxr9ByaC08YZUT_3K",
          { method: "HEAD" }
        );
        const lastModified = driveRes.headers.get("last-modified");
        if (lastModified) {
          const date = new Date(lastModified);
          const day = date.getDate();
          const month = date.toLocaleString("en-US", { month: "long" });
          const year = date.getFullYear();
          setResumeDate(`Updated ${day} ${month}, ${year}`);
        }
      } catch (err) {
        console.error("Error fetching Resume date:", err);
      }
    };

    fetchCredlyBadges();
    fetchResumeDate();
  }, []);
  return (
    <div>
        <main>
  
        {Drop ? <RespSidebar setDropDown={setDrop}/> :  <Sidebar setDropDown={setDrop}/>}

  
  <div className="main-content">
    <Navbar link="resume"/>
    
    
      <article
        className="resume active"
        data-page="resume"
      >
        <header>
          <h2 className="h2 article-title typing-text">
            Professional Profile
          </h2>
        </header>
        <section className="timeline">
          <div className="title-wrapper">
            <div className="icon-box">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon sm:m-1.5 m-3" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M32 192L256 64l224 128-224 128L32 192z"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M112 240v128l144 80 144-80V240M480 368V192M256 320v128"/></svg>
            </div>
            <h3 className="h3">
              Education
            </h3>
          </div>
          <ol className="timeline-list">
            <li className="timeline-item">
              <h4 className="h4 timeline-item-title">
              YESHWANTRAO CHAVAN COLLEGE OF ENGINEERING
              </h4>
              <span>
                2022 — 2026
              </span>
              <p className="timeline-text">
                8.33 CGPA
              </p>
            </li>
          </ol>
        </section>
        <section className="timeline">
          <div className="title-wrapper">
            <div className="icon-box">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon sm:m-1.5 m-3 " viewBox="0 0 512 512"><rect x="32" y="128" width="448" height="320" rx="48" ry="48" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/><path d="M144 128V96a32 32 0 0132-32h160a32 32 0 0132 32v32M480 240H32M320 240v24a8 8 0 01-8 8H200a8 8 0 01-8-8v-24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
            </div>
            <h3 className="h3">
              Experience
            </h3>
          </div>
          <ol className="timeline-list">
            <li className="timeline-item">
              <h4 className="h4 timeline-item-title">
                Cognizant (Mar 2026 – Jun 2026)
              </h4>
              
              <p className="timeline-text">
                Java Full Stack Developer (React) Intern
              </p>
            </li>
            <li className="timeline-item">
              <h4 className="h4 timeline-item-title">
                DevOps and Cloud Computing
              </h4>
              
              <p className="timeline-text">
                Having experience working with AWS and GCP consoles.
              </p>
            </li>
          </ol>
        </section>
        <section>
        <h3 className="h3 skills-title">
            Important Links
          </h3>
          <ul className="important-links-list">
             <motion.div
      className="important-links-item"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
            <li className="important-links-item">
              <div className="important-links-card">
                <div className="card-top">
                  <div className="icon-box">
                    <FileText className="ionicon sm:m-1.5 m-3" />
                  </div>
                  <div className="card-text">
                    <div className="card-title-row">
                      <h3 className="card-title">Resume</h3>
                      <span className="card-badge">{resumeDate}</span>
                    </div>
                    <p className="card-description">Download my professional resume</p>
                  </div>
                </div>
                <div className="card-action">
                  <a href='https://drive.google.com/file/d/1ysYVYU9X6q3uBaLDxr9ByaC08YZUT_3K/view?usp=sharing' target='_blank' rel="noreferrer">
                    <Eye size={16} style={{marginRight: '4px'}} />
                    Have a Look
                  </a>
                </div>
              </div>
            </li>
            </motion.div>
             <motion.div
      className="important-links-item"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
            <li className="important-links-item">
              <div className="important-links-card">
                <div className="card-top">
                  <div className="icon-box">
                    <Award className="ionicon sm:m-1.5 m-3" />
                  </div>
                  <div className="card-text">
                    <div className="card-title-row">
                      <h3 className="card-title">Credly</h3>
                      <span className="card-badge">{`${badgeCount} Badges`}</span>
                    </div>
                    <p className="card-description">View my certifications and badges</p>
                  </div>
                </div>
                <div className="card-action">
                  <a href="https://www.credly.com/users/ujwalhiranwar" target='_blank' rel="noreferrer">
                    <ExternalLink size={16} style={{marginRight: '4px'}} />
                    View Badges
                  </a>
                </div>
              </div>
            </li>
            </motion.div>
             <motion.div
      className="important-links-item"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
            <li className="important-links-item">
              <div className="important-links-card">
                <div className="card-top">
                  <div className="icon-box">
                    <Github className="ionicon sm:m-1.5 m-3" />
                  </div>
                  <div className="card-text">
                    <div className="card-title-row">
                      <h3 className="card-title">GitHub</h3>
                      <span className="card-badge">{`${repoCount} Repositories`}</span>
                    </div>
                    <p className="card-description">Explore my code repositories</p>
                  </div>
                </div>
                <div className="card-action">
                  <a href='https://github.com/Ujwal-Hiranwar?tab=repositories' target='_blank' rel="noreferrer">
                    <ExternalLink size={16} style={{marginRight: '4px'}} />
                    View Projects
                  </a>
                </div>
              </div>
            </li>
            </motion.div>
          </ul>
        </section>


        <section className="testimonials mt-8">
          <div className="title-wrapper">
            
            <h3 className="h3 testimonials-title">
              Certificates I've Gained
            </h3>
          </div>
          <ul className="testimonials-list has-scrollbar flex overflow-hidden">
            
            <li className="testimonials-item">
              <button onClick={()=>{
                setShowCertificate1({
                  isShow: true,
                  cretificateName : "IBM DevOps & SW Engineering",
                  cretificateDescripton : "Completed IBM’s 13-course Professional Certificate covering DevOps, Agile, Linux, GitHub, Docker, Kubernetes, CI/CD, microservices, cloud computing, and application security.",
                  certificateImageSrc : ibm,
                  cretificateLink : "https://www.coursera.org/account/accomplishments/professional-cert/ZOM7C3DWSCF9",
                  certificateDate : "4 Nov, 2024"
                })
              }}>
              
              <div className="content-card" data-testimonials-item="">
                <div className="flex items-center gap-3 mb-3">
                  <div className="icon-box flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="ionicon sm:m-1.5 m-3 text-green-400"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                      />
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                        d="M400 64l-48 112-96-128M112 64l48 112 96-128M256 448l-96-272M256 448l96-272"
                      />
                    </svg>
                  </div>
                  <h4
                    className="h4 testimonials-item-title !ml-0 line-clamp-1 truncate"
                    data-testimonials-title=""
                  >
                    IBM DevOps & SW Engineering
                  </h4>
                </div>
                <div
                  className="testimonials-text line-clamp-2 overflow-hidden"
                  data-testimonials-text=""
                >
                  <p className="line-clamp-2 overflow-hidden">
IBM Professional Certificate in DevOps, CI/CD, Docker, Kubernetes, and Cloud.
</p>
                </div>
              </div>
              </button>
            </li>
            <li className="testimonials-item">
              <button onClick={()=>{
                setShowCertificate1({
                  isShow: true,
                  cretificateName : "Associate Cloud Engineer",
                  cretificateDescripton : "Associate Cloud Engineers deploy applications, monitor operations, and manage enterprise solutions. They use Google Cloud Console and the command-line interface to perform common platform-based tasks to maintain one or more deployed solutions that leverage Google-managed or self-managed services on Google Cloud.",
                  certificateImageSrc : gcpace,
                  cretificateLink : "https://www.credly.com/badges/869fa78b-4f0f-413f-8fea-6ffd7d0e13f8/public_url",
                  certificateDate : "December 28, 2024"
                })
              }}>
              <div className="content-card" data-testimonials-item="">
                <div className="flex items-center gap-3 mb-3">
                  <div className="icon-box flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="ionicon sm:m-1.5 m-3 text-green-400"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                      />
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                        d="M400 64l-48 112-96-128M112 64l48 112 96-128M256 448l-96-272M256 448l96-272"
                      />
                    </svg>
                  </div>
                  <h4
                    className="h4 testimonials-item-title !ml-0 line-clamp-1 truncate"
                    data-testimonials-title=""
                  >
                    Associate Cloud Engineer (GCP)
                  </h4>
                </div>
                <div
                  className="testimonials-text line-clamp-2 overflow-hidden"
                  data-testimonials-text=""
                >
                  <p className="line-clamp-2 overflow-hidden">
                    This is my Associate Cloud Engineer certificate from Google Cloud Platform, Here I have learned various cloud services.
                  </p>
                </div>
              </div>
              </button>
            </li>
            <li className="testimonials-item">
              <button onClick={()=>{
                setShowCertificate1({
                  isShow: true,
                  cretificateName : "Oracle Generative AI Professional",
                  cretificateDescripton : "Completed Oracle’s Generative AI Professional certification covering OCI Generative AI services, foundation models, prompt engineering, AI agents, and cloud-based AI solutions.",
                  certificateImageSrc : genaioracle,
                  cretificateLink : "https://catalog-education.oracle.com/ords/certview/sharebadge?id=BE184F7C52D0F10F7375A3D7224A592489E621C9A5CACC2CB2E3AC192509A4EF",
                  certificateDate : "September 26, 2025"
                })
              }}>
              
              <div className="content-card" data-testimonials-item="">
                <div className="flex items-center gap-3 mb-3">
                  <div className="icon-box flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="ionicon sm:m-1.5 m-3 text-green-400"
                      viewBox="0 0 512 512"
                    >
                      <path
                        d="M35.42 188.21l207.75 269.46a16.17 16.17 0 0025.66 0l207.75-269.46a16.52 16.52 0 00.95-18.75L407.06 55.71A16.22 16.22 0 00393.27 48H118.73a16.22 16.22 0 00-13.79 7.71L34.47 169.46a16.52 16.52 0 00.95 18.75zM48 176h416"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                      />
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="32"
                        d="M400 64l-48 112-96-128M112 64l48 112 96-128M256 448l-96-272M256 448l96-272"
                      />
                    </svg>
                  </div>
                  <h4
                    className="h4 testimonials-item-title !ml-0 line-clamp-1 truncate"
                    data-testimonials-title=""
                  >
                    Oracle Generative AI Professional
                  </h4>
                </div>
                <div
                  className="testimonials-text line-clamp-2 overflow-hidden"
                  data-testimonials-text=""
                >
                  <p className="line-clamp-2 overflow-hidden">
                    Oracle certified expertise in Generative AI and OCI cloud technologies.
                  </p>
                </div>
              </div>
              </button>
            </li>
            
          </ul>
          <div className="text-center pt-2 text-white">Swipe to see more Certificates ➤ </div>
        </section>
        {ShowCertificate1.isShow ? <Certificate setshow={setShowCertificate1} 
        cerName={ShowCertificate1.cretificateName}
        cerImageSrc={ShowCertificate1.certificateImageSrc}
        cerLink={ShowCertificate1.cretificateLink}
        cerDescription={ShowCertificate1.cretificateDescripton}
        cerDate={ShowCertificate1.certificateDate}
        /> : null}
      </article>
    
    
  </div>
</main>
    </div>
  )
}
